import { FileRevisionID } from '@playq/octopus2-files';

import { useFileGetDownloadUrl } from '/api/hooks/filesService';
import type { SourceType, IHandlerProps } from '/shared/FilePreview/types';

import { ProcessPreview } from '../ProcessPreview';

export function FileRevisionHandler({ source, sourceName, ...rest }: IHandlerProps<FileRevisionID>) {
  const { data, error, isLoading } = useFileGetDownloadUrl(source, true, sourceName);
  const downloadData = data;

  const isComponentLoading = isLoading && !downloadData?.url && error === null;

  return <ProcessPreview url={data?.url} loading={isComponentLoading} {...rest} />;
}

FileRevisionHandler.canProcess = (source: SourceType): boolean => source instanceof FileRevisionID;
